import { render, staticRenderFns } from "./NumberValue.vue?vue&type=template&id=02a043e0&"
import script from "./NumberValue.vue?vue&type=script&lang=js&"
export * from "./NumberValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports